<template>
  <Dashboard title="Push notifications">
    <div
      id="pushNotifications"
      v-if="selectedApplicationId"
    >
      <Table
        recordsfoundishidden=true
        :data="pushs"
        :isloading="isLoading"
      >
        <template v-slot:titles>
          <th>ID</th>
          <th>Message</th>
          <th>Time</th>
          <th>Push type</th>
          <th>Active</th>
          <th></th>
        </template>

        <template v-slot:row>
          <tr
            v-for="(item, index) of pushs"
            class="item table--content"
            v-bind:key="index"
          >
            <TdId :id="item.id"/>

            <TdTitle
              :title="item.message"
            />

            <TdTitle
              :title="item.standardHour"
            />

            <TdTitle
              v-if="item.pushType === 0"
              title="Always"
            />

            <TdTitle
              v-else-if="item.pushType === 1"
              title="Daily"
            />

            <TdTitle
              v-else-if="item.pushType === 2"
              title="Other"
            />

            <TdTitle
              :title="item.active"
            />

            <TdButtons>
              <RoundedButton
                title="Edit"
                v-on:handleClick="handleModal(item)"
              >
                <EditIcon/>
              </RoundedButton>
            </TdButtons>
          </tr>
        </template>
      </Table>

      <Modal
        closeIcon="true"
        v-on:close="handleModal"
        v-if="!modal.isHidden"
      >
        <template v-slot:title>
          <h3>Edit push notification</h3>
        </template>

        <template v-slot:content>
          <div class="row">
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.data.title"
              v-model="modal.data.title"
            />

            <div class="col-24 input">
              <p>Message</p>

              <textarea v-model="modal.data.message"/>
            </div>

            <Input
              class="col-12"
              placeholder="Standard time"
              type="text"
              :value="modal.data.standardHour"
              v-model="modal.data.standardHour"
            />

            <div class="input col-12">
              <p>Last processed</p>

              {{ modal.data.lastProcessed }}
            </div>

            <div class="col-12 input">
              <p>Register event</p>

              <SwitchForm
                :isActive="modal.data.registerEvent"
                v-model="modal.data.registerEvent"
              />
            </div>

            <div class="col-12 input">
              <p>Preferred time</p>

              <SwitchForm
                :isActive="modal.data.userDefinedTime"
                v-model="modal.data.userDefinedTime"
              />
            </div>

            <div class="col-12 input">
              <p>Add on timeline</p>

              <SwitchForm
                :isActive="modal.data.addOnTimeline"
                v-model="modal.data.addOnTimeline"
              />
            </div>

            <div class="col-12 input">
              <p>Active</p>

              <SwitchForm
                :isActive="modal.data.active"
                v-model="modal.data.active"
              />
            </div>

            <div class="col-12 input">
              <p>Skip push</p>

              <SwitchForm
                :isActive="modal.data.skipPush"
                v-model="modal.data.skipPush"
              />
            </div>

            <div class="col-12 input">
              <p>Type</p>

              <div class="row">
                <div class="col-12 col-24-sm">
                  <RadioInput
                    placeholder="Always"
                    name="radio"
                    :checked="modal.data.pushType === 0"
                    v-on:handleClick="handleRadioInput(0)"
                  />

                  <RadioInput
                    placeholder="Daily"
                    name="radio"
                    :checked="modal.data.pushType === 1"
                    v-on:handleClick="handleRadioInput(1)"
                  />

                  <RadioInput
                    placeholder="Other"
                    name="radio"
                    :checked="modal.data.pushType === 2"
                    v-on:handleClick="handleRadioInput(2)"
                  />
                </div>
              </div>
            </div>

            <div class="col-24">
              <ButtonForm
                title="Save"
                v-on:handleClick="handleModalButton()"
              />
            </div>
          </div>
        </template>
      </Modal>
    </div>

    <NoApplicationSelected v-else/>
  </Dashboard>
</template>

<script>
  import { API } from '../../services/api.ts'
  import Dashboard from '../../components/dashboard/dashboard.vue'
  import NoApplicationSelected from '../../components/error/noApplicationSelected.vue'
  import Table from '../../components/table/table.vue'
  import TdTitle from '../../components/table/td/title.vue'
  import TdId from '../../components/table/td/id.vue'
  import TdButtons from '../../components/table/td/buttons.vue'
  import EditIcon from '../../icons/edit.vue'
  import RoundedButton from '../../components/buttons/roundedButton.vue'
  import Modal from '../../components/modal/modal.vue'
  import Input from '../../components/form/input.vue'
  import RadioInput from '../../components/form/radio.vue'
  import SwitchForm from '../../components/form/switch.vue'
  import ButtonForm from '../../components/form/button.vue'
  import moment from 'moment';

  export default {
    name: 'Pages',
    components: {
      Dashboard,
      NoApplicationSelected,
      Table,
      TdTitle,
      TdId,
      TdButtons,
      EditIcon,
      RoundedButton,
      Modal,
      Input,
      RadioInput,
      SwitchForm,
      ButtonForm
    },
    data() {
      return {
        selectedApplicationId: localStorage.selectedApplicationId,
        isLoading: true,
        pushs: [],
        modal: {
          isHidden: true,
          id: 0,
          data: {}
        }
      }
    },
    methods: {
      handleModal: function(data) {
        if (this.modal.isHidden === true) {
          this.modal.preview = data.preview;
          this.modal.id = data.id;

          API.get(
            `index.cfm?act=pushmessages.item&id=${data.id}`
          ).then(
            response => {
              console.log(response.data.data);

              this.modal.data = response.data.data;
              this.modal.data.lastProcessed = moment.utc(this.modal.data.lastProcessed).format('D MMMM YYYY HH:mm:ss');

              this.modal.isHidden = false;
            }
          )
        } else {
          this.modal.isHidden = true;
        }
      },
      handleRadioInput: function(type) {
        this.modal.data.pushType = type;
      },
      handleModalButton: function() {
        API.patch(
          `index.cfm?act=pushmessages.item&id=${this.modal.id}`,
          {
            active: this.modal.data.active,
            addOnTimeline: this.modal.data.addOnTimeline,
            message: this.modal.data.message,
            pushType: this.modal.data.pushType,
            registerEvent: this.modal.data.registerEvent,
            skipPush: this.modal.data.skipPush,
            standardHour: this.modal.data.standardHour,
            title: this.modal.data.title,
            userDefinedTime: this.modal.data.userDefinedTime,
          }
        ).then(
          response => {
            location.reload();
          }
        )
      }
    },
    mounted() {
      const self = this;

      API.get(
        `index.cfm?act=pushmessages.list`
      ).then(
        response => {
          console.log(response.data.data);
          this.isLoading = false;
          this.pushs = response.data.data;
        }
      ).catch(function (error) {
        if (error.response.status === 403) {
          localStorage.removeItem('selectedApplicationName');
          localStorage.removeItem('selectedApplicationId');
          self.selectedApplicationId = null
        }
      });
    }
  }
</script>

<style lang="scss">
  #pushNotifications {
    .switch {
      margin-bottom: 15px;
    }

    textarea {
      width: 100%;
      height: 100px;
      margin-bottom: 13px;
      padding: 10px;
      border: 1px solid var(--blue-medium);
      outline: 0;
    }
  }
</style>
